import React from 'react';

import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import FilesListRow from './filesListRow';

const FilesList = ({ filesList, removeFileFromList, orderId }) => {
  return (
    <>
      <div className="card">
        <div className="card-header">
          <Typography heading="h4" variant={{ size: 'h4' }} block>List of user uploaded files</Typography>
        </div>
        <ul className="list-group list-group-flush">
          {filesList.map(file => (
            <FilesListRow
              key={file.fileId}
              orderId={orderId}
              fileData={file}
              removeFileFromList={removeFileFromList}
            />
          ))}
        </ul>
      </div>
    </>
  );
};

FilesList.propTypes = {
  filesList: PropTypes.arrayOf(PropTypes.object).isRequired,
  removeFileFromList: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired
};

export default FilesList;
